import type { ReactNode } from "react"

import { cn } from "@/lib/utils"
import { Button, type ButtonProps } from "./button"

export type DialogActionsProps = {
  cancelLabel?: ReactNode
  confirmLabel?: ReactNode
  onCancel: () => void
  onConfirm?: () => void
  confirmType?: "button" | "submit"
  loading?: boolean
  disabled?: boolean
  cancelDisabled?: boolean
  confirmVariant?: ButtonProps["variant"]
  confirmClassName?: string
  cancelClassName?: string
  footerClassName?: string
  /** Só fechar (ex.: visualização). O rodapé fica oculto — use o X do modal. */
  hideConfirm?: boolean
}

/** Rodapé padrão de popups — mesmo layout das páginas de cadastro (`FormActions`). */
export function DialogActions({
  cancelLabel = "Voltar",
  confirmLabel,
  onCancel,
  onConfirm,
  confirmType = "button",
  loading = false,
  disabled = false,
  cancelDisabled,
  confirmVariant = "default",
  confirmClassName,
  cancelClassName,
  footerClassName,
  hideConfirm = false,
}: DialogActionsProps) {
  if (hideConfirm) {
    return null
  }

  return (
    <div
      className={cn(
        "flex shrink-0 flex-col-reverse gap-3 border-t border-border bg-card-surface p-6 pt-4 sm:flex-row sm:items-stretch",
        footerClassName)}
    >
      <Button
        type={confirmType}
        variant={confirmVariant}
        className={cn(
          "h-auto min-h-14 w-full whitespace-normal rounded-xl px-4 py-3 text-base font-bold leading-snug shadow-lg shadow-primary/20 transition-all hover:-translate-y-0.5 hover:shadow-primary/40 sm:min-w-0 sm:flex-1",
          confirmClassName)}
        onClick={onConfirm}
        disabled={disabled || loading}
        loading={loading}
      >
        {confirmLabel}
      </Button>
      <Button
        type="button"
        variant="outline"
        className={cn(
          "h-auto min-h-14 w-full whitespace-normal rounded-xl border-2 border-border px-4 py-3 text-base font-bold leading-snug hover:bg-muted/30 dark:hover:bg-white/5 sm:min-w-0 sm:flex-1",
          cancelClassName)}
        onClick={onCancel}
        disabled={cancelDisabled ?? loading}
      >
        {cancelLabel}
      </Button>
    </div>
  )
}
